import "./App.scss";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Routes, UnderMaintenanceRoutes } from "./Routes";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { useEffect, useState } from "react";
import Loader from "./common/Loader/Loader";
import { ClaimsProvider } from "./services/ClaimsService";
import LogRocket from 'logrocket';
import QueuedOperationsPanel from "./components/QueuedOperationsPanel";

// Initialize globally, and only if the app ID is set. For now, only Beta and Prod
if (LogRocket && process.env.REACT_APP_LOGROCKET_APPID) {
  LogRocket.init(process.env.REACT_APP_LOGROCKET_APPID);
  console.log('LogRocket initialized');
}
else{
	console.log('no');
}

function AppRoutes({ routes }) {
    const router = createBrowserRouter(routes);
    return <RouterProvider router={router} />;
}

function App() {
	const [routes, setRoutes] = useState();
	const showUnderMaintenance = process.env.REACT_APP_SHOW_UNDER_MAINTENANCE;
	useEffect(() => {
		// Set routes based on the maintenance flag
		if (showUnderMaintenance === "true") {
			setRoutes(UnderMaintenanceRoutes);
		} else {
			setRoutes(Routes);
		}
	}, [showUnderMaintenance]);

	// Only create the router when routes are ready
	if (!routes) {
		return <Loader />; // Or a better loading indicator
	}

    return (
        <Provider store={store}>
            <ClaimsProvider>
                <div className="App">
                    <AppRoutes routes={routes} />
                </div>
                <QueuedOperationsPanel />
            </ClaimsProvider>
        </Provider>
    );
}

export default App;
